import { EstimatorOption } from '@components/estimateur-etape/models';
import { imageMock } from '@mock/schema/components/shared/image.mock';
import { getNumberId } from '@shared/utils';

export const estimatorOptionMock = (
  withCostLevel: boolean = false,
  withDescription: boolean = false
): EstimatorOption => ({
  id: getNumberId(),
  image: imageMock,
  costLevel: withCostLevel ? Math.floor(Math.random() * 3) + 1 : undefined,
  name: `Name ${getNumberId()}`,
  description: withDescription ? `Description ${getNumberId()}` : undefined,
});
